const WHATSAPP_LINK = 'https://wa.me/573057096663?text=Hola%2C%20%C2%BFEn%20qu%C3%A9%20podemos%20ayudarte%3F';

const mainCarriers = [
  {
    name: 'Interrapidísimo',
    description: 'Cobertura nacional con entrega express a más de 1.000 municipios en Colombia.',
    icon: 'ri-flashlight-line',
    color: 'text-yellow-400',
    bg: 'bg-yellow-500/10',
    border: 'border-yellow-500/30',
    tag: 'Express',
    tagColor: 'bg-yellow-500/20 text-yellow-300',
  },
  {
    name: 'Envia',
    description: 'Red logística con presencia en todo el territorio nacional. Rápido, seguro y rastreable.',
    icon: 'ri-truck-line',
    color: 'text-green-400',
    bg: 'bg-green-500/10',
    border: 'border-green-500/30',
    tag: 'Rastreable',
    tagColor: 'bg-green-500/20 text-green-300',
  },
  {
    name: 'Servientrega',
    description: 'La transportadora más reconocida de Colombia. Entrega garantizada a cualquier rincón del país.',
    icon: 'ri-map-2-line',
    color: 'text-red-400',
    bg: 'bg-red-500/10',
    border: 'border-red-500/30',
    tag: 'Nacional',
    tagColor: 'bg-red-500/20 text-red-300',
  },
];

const secondaryCarriers = [
  {
    name: 'Extelar Express',
    icon: 'ri-send-plane-line',
    color: 'text-slate-300',
  },
  {
    name: 'Taxis Verdes',
    icon: 'ri-taxi-line',
    color: 'text-slate-300',
  },
];

const steps = [
  {
    number: '01',
    icon: 'ri-whatsapp-line',
    title: 'Cotiza por WhatsApp',
    desc: 'Escríbenos con el repuesto que necesitas y tu ciudad.',
  },
  {
    number: '02',
    icon: 'ri-checkbox-circle-line',
    title: 'Confirmamos disponibilidad',
    desc: 'Te confirmamos stock y precio en minutos.',
  },
  {
    number: '03',
    icon: 'ri-bank-card-line',
    title: 'Realizas el pago',
    desc: 'Transferencia, Nequi o efectivo en punto de envío.',
  },
  {
    number: '04',
    icon: 'ri-truck-line',
    title: 'Enviamos el mismo día',
    desc: 'Despachamos con la transportadora de tu preferencia.',
  },
];

export default function Shipping() {
  return (
    <section id="envios" className="bg-[#0d0d0d] py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 border border-[#2563eb]/40 text-[#2563eb] text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-4">
            <i className="ri-truck-line"></i>
            Envíos a Todo Colombia
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            Tu Repuesto Llega<br />
            <span className="text-[#2563eb]">Hasta Donde Estés</span>
          </h2>
          <p className="text-gray-400 text-base max-w-2xl mx-auto">
            No importa si estás en Bogotá, Leticia, Riohacha o el municipio más apartado de Colombia — trabajamos con las mejores transportadoras del país para que tu repuesto llegue seguro y rápido.
          </p>
        </div>

        {/* Hero banner */}
        <div
          className="relative rounded-2xl overflow-hidden mb-10 md:mb-16 h-56 sm:h-64 md:h-80"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=aerial%20view%20of%20Colombia%20map%20roads%20highways%20logistics%20network%20transportation%20trucks%20delivery%20vehicles%20dark%20moody%20cinematic%20photography%20from%20above%20country%20roads%20connecting%20cities%20towns%20villages%20dramatic%20lighting&width=1400&height=600&seq=ship001&orientation=landscape')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-black/30"></div>
          <div className="relative z-10 h-full flex flex-col justify-center px-6 md:px-14 py-6">
            <div className="flex items-center gap-3 mb-3 md:mb-4">
              <span className="w-3 h-3 rounded-full bg-[#2563eb] animate-pulse"></span>
              <span className="text-[#2563eb] font-bold text-sm uppercase tracking-widest">Cobertura Nacional Activa</span>
            </div>
            <h3 className="text-white text-xl sm:text-2xl md:text-4xl font-extrabold mb-2 md:mb-3 max-w-lg leading-tight">
              Más de 1.000 municipios<br />en todo el país
            </h3>
            <p className="text-gray-300 text-sm md:text-base max-w-md">
              Desde el Amazonas hasta La Guajira. Desde el Pacífico hasta los Llanos. Tu repuesto mecánico llega.
            </p>
          </div>
          {/* Stats overlay - desktop only */}
          <div className="absolute right-6 md:right-14 top-1/2 -translate-y-1/2 hidden md:flex flex-col gap-4">
            {[
              { value: '1.000+', label: 'Municipios' },
              { value: '24-72h', label: 'Tiempo de entrega' },
              { value: '100%', label: 'Rastreable' },
            ].map((s) => (
              <div key={s.label} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-5 py-3 text-center">
                <div className="text-[#2563eb] font-extrabold text-lg">{s.value}</div>
                <div className="text-gray-300 text-xs">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile stats */}
        <div className="flex md:hidden justify-center gap-3 mb-10">
          {[
            { value: '1.000+', label: 'Municipios' },
            { value: '24-72h', label: 'Entrega' },
            { value: '100%', label: 'Rastreable' },
          ].map((s) => (
            <div key={s.label} className="bg-[#1a1a1a] border border-gray-800 rounded-xl px-4 py-3 text-center flex-1">
              <div className="text-[#2563eb] font-extrabold text-sm">{s.value}</div>
              <div className="text-gray-400 text-[10px]">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Main carriers */}
        <div className="mb-6">
          <p className="text-center text-gray-500 text-xs uppercase tracking-widest font-semibold mb-6 md:mb-8">
            Transportadoras principales
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {mainCarriers.map((carrier) => (
              <div
                key={carrier.name}
                className={`bg-[#1a1a1a] rounded-xl p-5 md:p-7 border ${carrier.border} hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden`}
              >
                {/* Background glow */}
                <div className={`absolute top-0 right-0 w-32 h-32 rounded-full blur-3xl opacity-10 ${carrier.bg}`}></div>

                <div className="flex items-start justify-between mb-5 relative z-10">
                  <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${carrier.bg} flex-shrink-0`}>
                    <i className={`${carrier.icon} text-2xl ${carrier.color}`}></i>
                  </div>
                  <span className={`text-xs font-bold px-3 py-1 rounded-full ${carrier.tagColor}`}>
                    {carrier.tag}
                  </span>
                </div>

                <h3 className="text-white font-extrabold text-xl mb-2 relative z-10">{carrier.name}</h3>
                <p className="text-gray-400 text-sm leading-relaxed relative z-10">{carrier.description}</p>

                <div className={`mt-5 h-0.5 w-12 rounded-full ${carrier.bg} relative z-10`}></div>
              </div>
            ))}
          </div>
        </div>

        {/* Secondary carriers */}
        <div className="mb-16">
          <p className="text-center text-gray-600 text-xs uppercase tracking-widest font-semibold mb-5">
            También trabajamos con
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {secondaryCarriers.map((c) => (
              <div
                key={c.name}
                className="flex items-center gap-2.5 bg-[#1a1a1a] border border-gray-800 rounded-full px-5 py-2.5"
              >
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`${c.icon} text-base ${c.color}`}></i>
                </div>
                <span className="text-gray-400 text-sm font-medium">{c.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* How it works */}
        <div className="bg-[#1a1a1a] rounded-2xl border border-gray-800/60 p-8 md:p-12 mb-12">
          <div className="text-center mb-10">
            <h3 className="text-white text-2xl md:text-3xl font-extrabold mb-2">
              ¿Cómo funciona el envío?
            </h3>
            <p className="text-gray-500 text-sm">Simple, rápido y sin complicaciones</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((step, idx) => (
              <div key={step.number} className="relative flex flex-col items-center text-center">
                {/* Connector line */}
                {idx < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-7 left-[calc(50%+28px)] w-[calc(100%-56px)] h-px bg-gray-700 border-dashed border-t border-gray-700"></div>
                )}
                <div className="w-14 h-14 flex items-center justify-center bg-[#2563eb]/10 border border-[#2563eb]/30 rounded-full mb-4 relative z-10">
                  <i className={`${step.icon} text-xl text-[#2563eb]`}></i>
                </div>
                <span className="text-[#2563eb] text-xs font-black uppercase tracking-widest mb-1">{step.number}</span>
                <h4 className="text-white font-bold text-sm mb-1">{step.title}</h4>
                <p className="text-gray-500 text-xs leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-gray-400 text-base mb-2 font-medium">
            ¿Estás fuera de Bogotá? No hay problema.
          </p>
          <p className="text-gray-500 text-sm mb-6">
            Escríbenos por WhatsApp, dinos tu ciudad y te coordinamos el envío de inmediato.
          </p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-3 bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-bold px-10 py-4 rounded-full text-base transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-blue-900/30"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Cotizar con Envío a Mi Ciudad
          </a>
        </div>

      </div>
    </section>
  );
}
